// SPDX-License-Identifier: AGPL-3.0-or-later

import {makeAutoObservable} from 'mobx';

export type TasksTabName = 'mine' | 'board';

class TasksTab {
	tab: TasksTabName = 'mine';

	constructor() {
		makeAutoObservable(this, {}, {autoBind: true});
	}

	setTab(tab: TasksTabName): void {
		this.tab = tab;
	}
}

export default new TasksTab();
